// ================================================================
//  O.W.L. — Other Way Living  |  Shopify Theme JS
//  Cart uses Shopify AJAX Cart API (no token needed)
// ================================================================

// ─── SHOPIFY AJAX CART ───────────────────────────────────────

async function getCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function cartAdd(variantId) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.description || 'Could not add to cart');
  }
  return getCart();
}

async function cartChangeLine(line, quantity) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line, quantity }),
  });
  return res.json();
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// ─── CART UI ─────────────────────────────────────────────────

function renderCart(cart) {
  const badge   = document.getElementById('cart-badge');
  const totalEl = document.getElementById('cart-total');
  const footer  = document.getElementById('cart-footer');
  const items   = document.getElementById('cart-items');

  badge.textContent = cart.item_count;
  badge.classList.toggle('visible', cart.item_count > 0);
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  if (footer)  footer.style.display = cart.item_count > 0 ? 'block' : 'none';

  if (!items) return;

  if (cart.items.length === 0) {
    items.innerHTML = `
      <div class="cart-empty">
        <svg width="48" height="48" viewBox="0 0 72 72" fill="none" opacity="0.25">
          <ellipse cx="36" cy="44" rx="20" ry="22" fill="none" stroke="#5c7a5c" stroke-width="2.5"/>
          <ellipse cx="36" cy="24" rx="16" ry="14" fill="none" stroke="#5c7a5c" stroke-width="2.5"/>
          <circle cx="29" cy="23" r="5.5" fill="#d4a832"/>
          <circle cx="43" cy="23" r="5.5" fill="#d4a832"/>
          <circle cx="29" cy="23" r="3"   fill="#2a2520"/>
          <circle cx="43" cy="23" r="3"   fill="#2a2520"/>
        </svg>
        <div class="cart-empty-title">Your cart is empty</div>
        <div class="cart-empty-sub">Add something worth carrying.</div>
      </div>`;
    return;
  }

  items.innerHTML = cart.items.map((item, idx) => {
    const lineNum  = idx + 1;
    const imgUrl   = item.image ? item.image.replace(/(\.\w+)$/, '_120x120$1') : '';
    const variant  = item.variant_title && item.variant_title !== 'Default Title'
                     ? `<div class="cart-item-variant">${item.variant_title}</div>` : '';
    return `
      <div class="cart-item">
        <div class="cart-item-img">
          ${imgUrl ? `<img src="${imgUrl}" alt="${item.product_title}">` : ''}
        </div>
        <div class="cart-item-info">
          <div class="cart-item-name">${item.product_title}</div>
          ${variant}
          <div class="cart-item-price">${formatMoney(item.price)} each</div>
          <div class="cart-item-actions">
            <button class="qty-btn" onclick="updateLine(${lineNum}, ${item.quantity - 1})">−</button>
            <span class="qty-num">${item.quantity}</span>
            <button class="qty-btn" onclick="updateLine(${lineNum}, ${item.quantity + 1})">+</button>
            <button class="remove-btn" onclick="updateLine(${lineNum}, 0)">Remove</button>
          </div>
        </div>
      </div>`;
  }).join('');
}

// ─── CART ACTIONS ─────────────────────────────────────────────

async function handleAddToCart(btn) {
  const variantId = btn.dataset.variantId;
  const title     = btn.dataset.title;
  if (!variantId) return;

  btn.textContent = '...';
  btn.disabled    = true;

  try {
    const cart = await cartAdd(variantId);
    renderCart(cart);
    openCart();
    showToast(`${title} added to cart`, '🦉');
  } catch (e) {
    showToast(e.message, '⚠');
  } finally {
    btn.textContent = 'Add to Cart';
    btn.disabled    = false;
  }
}

async function updateLine(line, quantity) {
  try {
    const cart = await cartChangeLine(line, quantity);
    renderCart(cart);
  } catch (e) {
    showToast('Could not update cart', '⚠');
  }
}

function proceedToCheckout() {
  window.location.href = '/checkout';
}

// ─── CART DRAWER OPEN / CLOSE ─────────────────────────────────

function openCart() {
  document.getElementById('cart-overlay').classList.add('open');
  document.getElementById('cart-drawer').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.getElementById('cart-overlay').classList.remove('open');
  document.getElementById('cart-drawer').classList.remove('open');
  document.body.style.overflow = '';
}
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

// ─── COLLECTION ACCORDION ─────────────────────────────────────

function toggleCollection(id) {
  const item = document.querySelector(`[data-collection="${id}"]`);
  const grid = document.getElementById(`grid-${id}`);
  if (!item || !grid) return;
  const isOpen = item.classList.contains('open');
  item.classList.toggle('open', !isOpen);
  grid.classList.toggle('open', !isOpen);
  // Expand to fit ALL products. The CSS cap was clipping products on mobile,
  // where the 2-column layout is much taller and the overflow rows became
  // unreachable (no way to scroll to them).
  if (!isOpen) {
    grid.style.maxHeight = grid.scrollHeight + 'px';
  } else {
    grid.style.maxHeight = '';
  }
}

// Re-measure any open collection on resize / orientation change so it never
// clips its products after the layout reflows.
window.addEventListener('resize', () => {
  document.querySelectorAll('.collection-grid-wrap.open').forEach(grid => {
    grid.style.maxHeight = grid.scrollHeight + 'px';
  });
});

// ─── FAQ ACCORDION ────────────────────────────────────────────

function toggleFaq(btn) {
  const item   = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

// ─── MOBILE MENU ──────────────────────────────────────────────

function toggleMobileMenu() {
  document.getElementById('mobile-menu').classList.toggle('open');
  document.getElementById('hamburger').classList.toggle('open');
}
function closeMobileMenu() {
  document.getElementById('mobile-menu').classList.remove('open');
  document.getElementById('hamburger').classList.remove('open');
}

// ─── TOAST ────────────────────────────────────────────────────

function showToast(msg, icon = '✓') {
  const container = document.getElementById('toast-container');
  const toast     = document.createElement('div');
  toast.className = 'toast';
  toast.innerHTML = `<span class="toast-icon">${icon}</span><span>${msg}</span>`;
  container.appendChild(toast);
  requestAnimationFrame(() => requestAnimationFrame(() => toast.classList.add('show')));
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => toast.remove(), 400);
  }, 3000);
}

// ─── CONTACT FORM ─────────────────────────────────────────────

function submitContact(e) {
  // Shopify handles form submission natively via {% form 'contact' %}
  // This is only called if JS intercept is needed
  const successEl = document.getElementById('contact-success');
  if (successEl) {
    e.preventDefault();
    showToast("Message sent! We'll be in touch soon.", '✉');
    successEl.style.display = 'block';
    e.target.reset();
  }
}

// ─── NEWSLETTER ───────────────────────────────────────────────

function newsletterSignup(e) {
  e.preventDefault();
  const input = e.target.previousElementSibling;
  if (input && input.value) {
    showToast('Welcome to the Flock!', '🦉');
    input.value = '';
  }
}

// ─── NAVBAR SCROLL ────────────────────────────────────────────

window.addEventListener('scroll', () => {
  document.getElementById('navbar').classList.toggle('scrolled', window.scrollY > 60);
}, { passive: true });

// ─── SCROLL ANIMATIONS ────────────────────────────────────────

const _observer = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
document.querySelectorAll('.fade-up').forEach(el => _observer.observe(el));

// ─── LOADING SCREEN ───────────────────────────────────────────

window.addEventListener('load', () => {
  setTimeout(() => document.getElementById('loading').classList.add('hidden'), 1600);
  // Initialise cart count from Shopify session
  getCart().then(renderCart).catch(() => {});
});
